import { Day } from './day.model'
import { Activity } from './activity.model'
import { Lecturer } from './lecturer.model'

export class DayProgram {
    public Dia: Day;
    public Atividades: Array<Activity>;
    public Palestrantes: Array<Lecturer>;
    public DataPermiteAvaliacaoParticipante: boolean;
    public CategoriasVagasLimitadas: Array<number>;
    public InitAtividades: Array<Activity>;

}


// WEBPACK FOOTER //
// ./src/models/day-program.model.ts